import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Calendar } from '@components/ui/calendar';
import { Button } from '@components/ui/button';
import { FormField, FormMessage } from '@components/ui/form';
import { FormLabel } from '@components/ui/form';
import { formatDate } from '@utils/i18n';
import { AddTaskScheduleFormValues } from '@forms/jobs/addTaskSchedule/types';
import { getExcludedDays, getSelectedDays, toggleDay } from '@forms/jobs/addTaskSchedule/helpers';
import { dayModifiersClassNames } from '../constants';

export const JobStageScheduleDialogDays = () => {
  const { t } = useTranslation('app', { keyPrefix: 'pages.job.addTaskSchedule.days' });
  const { control } = useFormContext<AddTaskScheduleFormValues>();

  return (
    <FormField
      control={control}
      name="days"
      render={({ field: { value, onChange } }) => {
        const picked = getSelectedDays(value);
        const skipped = getExcludedDays(value);
        const first = picked[0];
        const last = picked[picked.length - 1];

        return (
          <div className="flex flex-col gap-1">
            <FormLabel>{t('label')}</FormLabel>
            <p className="text-sm text-neutral-500">{t('hint')}</p>
            <div className="flex justify-center rounded border border-neutral-200">
              <Calendar
                defaultMonth={value.from || undefined}
                weekStartsOn={1}
                modifiers={{ picked, skipped }}
                modifiersClassNames={dayModifiersClassNames}
                onDayClick={(day) => onChange(toggleDay(value, day))}
              />
            </div>
            <div className="flex min-h-8 items-center justify-between gap-2">
              <span className="text-sm text-neutral-700">
                {first && last
                  ? [
                      t('summary', {
                        count: picked.length,
                        range:
                          picked.length > 1
                            ? `${formatDate(first)} – ${formatDate(last)}`
                            : formatDate(first),
                      }),
                      skipped.length ? t('skipped', { count: skipped.length }) : '',
                    ]
                      .filter(Boolean)
                      .join(' · ')
                  : t('empty')}
              </span>
              {value.from && (
                <Button
                  variant="ghost"
                  className="h-8"
                  onClick={() => onChange({ from: null, to: null, excluded: [] })}>
                  {t('clear')}
                </Button>
              )}
            </div>
            <FormMessage />
          </div>
        );
      }}
    />
  );
};
